import { render } from "./PageFormKesehatan.vue?vue&type=template&id=34999847"
import script from "./PageFormKesehatan.vue?vue&type=script&lang=js"
export * from "./PageFormKesehatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__